<template>
<teleport to="body">
  <div class="popup-container" v-if="open" @click="closePopup">
    <div class="popup-wrapper">
      <div class="popup-content" @click.stop="">
        <slot name="header" />
        <slot />
      </div>
    </div>
  </div>
</teleport>
</template>
<script>
import Popup from './Popup.js';
export default Popup;

</script>
